import React from 'react';
import style from './NestedTableNameDisplay.scss';
import { Text } from '../../../PageElements/Text';
import ChevronRightCircle from 'wix-ui-icons-common/ChevronRightCircle';
import classnames from 'classnames';
import { Caption } from '../../../PageElements/Caption';
import { Text as WSRText } from 'wix-style-react';

export const NestedTableNameDisplay = React.memo(
  ({
    name,
    isRotated,
    deprecated,
    required,
    optional,
    readOnly,
    shouldBeAbleToExpand,
  }: {
    name: string;
    isRotated: boolean;
    deprecated: boolean;
    required: boolean;
    optional: boolean;
    readOnly: boolean;
    shouldBeAbleToExpand: boolean;
  }) => {
    return (
      <div className={style.nameWrapper}>
        <span
          className={classnames({
            [style.iconContainer]: shouldBeAbleToExpand,
            [style.empty]: !shouldBeAbleToExpand,
          })}
        >
          {shouldBeAbleToExpand && (
            <React.Fragment>
              <ChevronRightCircle
                data-hook="expand-button"
                className={style.chevronIcon}
                style={{
                  transform: `rotate(${isRotated ? '90' : '0'}deg)`,
                }}
              />
              <button className={style.mobileBtn}>
                <Text size="tiny">{isRotated ? 'CLOSE' : 'EXPAND'}</Text>
              </button>
            </React.Fragment>
          )}
        </span>

        <div className={style.details}>
          <WSRText
            className={style.wixTextcontainer}
            dataHook="param-name"
            size="small"
            weight="bold"
            tagName="span"
            ellipsis
          >
            {name}
          </WSRText>
          <div style={{ lineHeight: '1.2' }}>
            {deprecated && (
              <Caption color="red" dataHook="deprecated-label">
                Deprecated
              </Caption>
            )}
            {deprecated && (required || optional) && <>, </>}
            {required && (
              <Caption color="yellow" dataHook="required-label">
                Required
              </Caption>
            )}
            {required && optional && <>, </>}
            {optional && <Caption dataHook="optional-label">Optional</Caption>}
            {readOnly && (
              <div data-hook="read-only-label">
                <Caption>Read</Caption> <Caption>Only</Caption>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  },
);
